<template>
  <v-main>
    <v-container v-if="facture" fluid :class="(payable ? 'facture-container' : 'facture-container-no-payment') + ' mx-auto d-flex flex-column'">
<!--      <Header />-->
      <Facture :facture="facture" :inputFields="false" :showAlert="true" :payable="payable" @cardDeleted="cardDeleted">
        <template v-slot:btn-paiement>
          <v-sheet flat class="overflow-hidden d-flex flex-column">
              <v-dialog v-model="showMonerisCheckout" persistent hide-overlay scrollable fullscreen :key="monerisDialogKey">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="primary" dark v-on="on" v-bind="attrs" x-large block :loading="paiementEnCours">
                    Payer
                    <v-icon right dark>
                      mdi-credit-card
                    </v-icon>
                  </v-btn>
                </template>
                <MonerisCheckout v-if="showMonerisCheckout" :idFacture="idFacture" @paiementEudonetStart="paiementEudonetStart" @paiementEudonetComplete="paiementEudonetComplete"></MonerisCheckout>
              </v-dialog>
          </v-sheet>
        </template>
      </Facture>
<!--      <Footer v-if="!showMonerisCheckout && !$vuetify.breakpoint.mobile" />-->
    </v-container>
  </v-main>
</template>

<script>
import { PublicApi } from "@/plugins/api"
import Facture from "../components/facture/Facture"
import MonerisCheckout from "../components/facture/moneris/MonerisCheckout"

export default {
  components: {
    Facture,
    MonerisCheckout,
  },
  data() {
    return {
      facture: null,
      showMonerisCheckout: false,
      monerisDialogKey: 0,
      paiementEnCours: false
    }
  },
  computed: {
    idFacture() {
      return this.$route.params.idFacture
    },
    payable() {
      return this.facture && !this.facture.jetonDeFacturation && this.facture.solde > 0 && this.facture.dejaPaye < this.facture.total
    }
  },
  mounted() {
    this.chargerLaFacture()
  },
  methods: {
    chargerLaFacture() {
      this.getFacture(this.idFacture)
        .then(async (response) => {
          this.facture = response.data
        })
        .catch((error) => {
          if (error.response.status === 404) {
            this.$router.push({
              name: "NotFound",
              message: error.response.status
            })
          } else {
            this.$router.push({
              name: "InternalError",
              message: error.response.message
            })
          }
        })
    },
    getFacture: (factureId) => PublicApi.get("moneris-checkout/" + factureId + "/invoice"),
    paiementEudonetStart() {
      this.paiementEnCours = true
    },
    paiementEudonetComplete() {
      this.chargerLaFacture()
      this.showMonerisCheckout = false
      this.monerisDialogKey += 1
      this.paiementEnCours = false
    },
    // Recharge les données de la facture lors de la suppression de la carte.
    cardDeleted() {
      this.chargerLaFacture()
    }
  }
}
</script>

<style>
.facture-container {
  max-width: 1280px;
  height: 100%;
}

.facture-container-no-payment {
  max-width: 800px;
}

.btn {
  text-transform: uppercase;
  letter-spacing: 1px;
}
</style>